<div mat-dialog-content class="border-b border-black/[.12]">
  <p class="py-4">
    Are you sure you want to unarchive the user
    {{ data.user.firstName }} {{ data.user.lastName }}?
  </p>
</div>
<div mat-dialog-actions class="flex justify-end">
  <button mat-flat-button (click)="onCancel()" [disabled]="isArchiving()">NO</button>
  <button mat-flat-button (click)="onConfirm()" [disabled]="isArchiving()">YES</button>
</div>
